// extracted by css-extract-rspack-plugin
export default {"root":"root-jmClSV","svg":"svg-F0htyt","svgisExpanded":"svgisExpanded-DG6qHv"};